import { Injectable, LOCALE_ID, OnInit } from '@angular/core'

import { Router } from '@angular/router'
import { LoginService } from 'src/app/login/services/login.service'
import { STORAGE_USER_LOGIN, STORAGE_USER, STORAGE_TOKEN } from 'src/app/app-settings'

@Injectable({
  providedIn: 'root',
})
export class NavbarService {
  generalRoute = false
  organizationsRoute = false
  supportRoute = false
  hotelRoute = false
  siteInstallationRoute = false

  paymentRoute = false

  constructor(
    private router: Router,
    private loginService: LoginService,
  ) {}

  redirectToPage(page: string): void {
    // TODO: Refactor
    if (page.includes('/general')) {
      this.generalRoute = true
      this.organizationsRoute = false
      this.supportRoute = false
      this.hotelRoute = false
      this.siteInstallationRoute = false
      this.paymentRoute = false
    } else if (page.includes('/organizations')) {
      this.organizationsRoute = true
      this.generalRoute = false
      this.supportRoute = false
      this.hotelRoute = false
      this.siteInstallationRoute = false
      this.paymentRoute = false
    } else if (page.includes('/support')) {
      this.organizationsRoute = false
      this.generalRoute = false
      this.supportRoute = true
      this.hotelRoute = false
      this.siteInstallationRoute = false
      this.paymentRoute = false
    } else if (page.includes('/payment')) {
      this.organizationsRoute = false
      this.generalRoute = false
      this.supportRoute = false
      this.hotelRoute = false
      this.siteInstallationRoute = false
      this.paymentRoute = true
    } else {
      this.organizationsRoute = false
      this.generalRoute = false
      this.supportRoute = false
      this.hotelRoute = false
      this.siteInstallationRoute = false
      this.paymentRoute = false
    }

    this.router.navigate([page])
  }

  // TODO: Anvend ny-opsat logout fra ag.api.security
  // Ny Logout-funktionalitet kan findes i /Security/API/V2/Security/Session/WebInternalUser/Logout

  logout() {
    this.loginService.logout(localStorage.getItem(STORAGE_USER_LOGIN)).subscribe((res) => {
      localStorage.removeItem(STORAGE_TOKEN)
      localStorage.removeItem(STORAGE_USER_LOGIN)
      localStorage.removeItem(STORAGE_USER)
      this.redirectToPage('/login')
    })
  }
}
